import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostQueryOptions } from './useJobPost';

export const useApplyExternalJobPost = (jobPostId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetchJson(`/job-posts/${jobPostId}/apply`, {
        method: 'POST',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(jobPostQueryOptions(jobPostId));
      queryClient.invalidateQueries({ queryKey: QueryKeys.jobPosts.index.root });
    },
  });
};
